import React from 'react';

const About: React.FC = () => {
  return (
    <section className="px-6 py-12 bg-white">
      {/* Main Title */}
      <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-8">
        What is GSMA Open Gateway?
      </h2>

      {/* Introductory Paragraphs with Light Blue Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 mb-8 space-y-6 bg-gray-100 p-6 rounded-lg shadow-md">
        <p>
          GSMA Open Gateway is a framework of common network Application Programmable Interfaces (APIs) designed to provide universal access to operator networks for developers.
        </p>
        <p>
          GSMA Open Gateway helps developers and cloud providers enhance and deploy services more quickly across operator networks via single points of access to the world’s largest connectivity platform.
        </p>
        <p>
          It enables the swift deployment of both existing and new services, providing developers with a streamlined path to access operator networks globally.
        </p>
        <p>
          The entire mobile ecosystem benefits from this initiative. 5G network capabilities will be exposed through data service APIs, making them more accessible across telecom networks, resulting in a seamless and controlled experience within a federated market.
        </p>
      </div>

      {/* Key Benefits Section with Green Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 mb-8 bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">Key Benefits of GSMA Open Gateway</h3>
        <ul className="list-disc pl-6 space-y-3">
          <li>Seamless customer experience across global networks</li>
          <li>Accelerated technology development, innovation, and commercial adoption (minimizing implementation effort)</li>
          <li>Fast-tracked education and promotion for global stakeholders</li>
          <li>Support for application portability across different telecom networks</li>
        </ul>
      </div>

      {/* CAMARA Project Section with Purple Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 mb-8 bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">The CAMARA Project and Its Role</h3>
        <p>
          CAMARA is an open-source project within the Linux Foundation focused on defining, developing, and testing the APIs necessary for the GSMA Open Gateway framework.
        </p>
        <p>
          CAMARA collaborates closely with the GSMA Operator Platform Group to ensure that API requirements are met and published effectively, providing fast and agile solutions with developer-friendly documentation. API definitions and reference implementations are made available for free under the Apache2.0 license.
        </p>
      </div>

      {/* 4G/5G Network Capabilities Section with Yellow Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 mb-8 bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">Leveraging 4G/5G Network Capabilities</h3>
        <p>
          4G and 5G network capabilities provide powerful functions. While many of these capabilities are already available in 4G, 5G introduces even more advanced features that enable better network information retrieval and configuration.
        </p>
        <p>
          The on-demand, secure, and controlled exposure of these capabilities facilitates transforming operator networks into service-enabling platforms. This transformation is key to providing enhanced customer experiences and facilitating application-to-network integration in the 5G era.
        </p>
      </div>

      {/* Abstraction from Network APIs Section with Light Red Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 mb-8 bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
          Simplifying Network APIs for Developers
        </h3>
        <p>
          A critical aspect of the GSMA Open Gateway framework is simplifying the complexity of telco networks, enabling developers without telecom expertise to easily consume these APIs.
        </p>
        <ul className="list-disc pl-6 space-y-3">
          <li>Abstracting complex telecom systems into user-friendly APIs</li>
          <li>Ensuring compliance with data privacy and regulatory standards</li>
          <li>Enabling smooth application-to-network integration</li>
        </ul>
      </div>

      {/* Global Availability Section with Light Teal Background */}
      <div className="max-w-4xl mx-auto text-lg text-gray-700 bg-gray-100 p-6 rounded-lg shadow-md">
        <h3 className="text-2xl font-semibold text-gray-800 mb-4">
          Ensuring Global Availability Across Telco Networks
        </h3>
        <p>
          To maintain a seamless customer experience, GSMA Open Gateway ensures APIs are available across different telecom networks and regions, overcoming geographic barriers and enabling applications to operate seamlessly worldwide.
        </p>
        <ul className="list-disc pl-6 space-y-3">
          <li>Ensuring a consistent customer experience regardless of location</li>
          <li>Accelerating technology development and reducing integration time</li>
          <li>Supporting global scalability and the portability of applications across telco networks</li>
        </ul>
      </div>
    </section>
  );
};

export default About;
